import React, { useCallback, useState } from 'react';
const createHoverMonitor = () => {
    let isHoverEnabled = false;
    let lastTouchTime = 0;
    const HOVER_THRESHOLD_MS = 500;
    function enableHover() {
        if (isHoverEnabled || Date.now() - lastTouchTime < HOVER_THRESHOLD_MS) {
            return;
        }
        isHoverEnabled = true;
    }
    function disableHover() {
        lastTouchTime = (new Date()).getTime();
        if (isHoverEnabled) {
            isHoverEnabled = false;
        }
    }
    if (typeof document !== 'undefined') {
        document.addEventListener('touchstart', disableHover, true);
        document.addEventListener('touchmove', disableHover, true);
        document.addEventListener('mousemove', enableHover, true);
    }
    return {
        get isEnabled() {
            return isHoverEnabled;
        }
    };
};
const hover = createHoverMonitor();
export const Hoverable = ({ children, onHoverIn, onHoverOut, }) => {
    const [isHovered, setIsHovered] = useState(false);
    const [showHover, setShowHover] = React.useState(true);
    const handleMouseEnter = useCallback(() => {
        if (hover.isEnabled) {
            setIsHovered((ih) => {
                if (!ih && onHoverIn) {
                    onHoverIn();
                    return true;
                }
                else {
                    return false;
                }
            });
        }
    }, [isHovered, onHoverIn]);
    const handleMouseLeave = useCallback(() => {
        setIsHovered((ih) => {
            if (ih && onHoverOut) {
                onHoverOut();
                return false;
            }
            else {
                return true;
            }
        });
    }, [isHovered, onHoverOut]);
    const handleGrant = useCallback(() => {
        setShowHover(false);
    }, []);
    const handleRelease = useCallback(() => {
        setShowHover(true);
    }, []);
    const child = typeof children === 'function' ? children(showHover && isHovered) : children;
    return React.cloneElement(React.Children.only(child), {
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        onResponderGrant: handleGrant,
        onResponderRelease: handleRelease,
    });
};
export default Hoverable;
//# sourceMappingURL=Hoverable.web.js.map